import React, { useState, useEffect, useRef } from 'react';

/**
 * Simple read-only dropdown for selecting from a list of options.
 *
 * Before: embedded inside InvoiceModal.js as a ~40-line sub-component.
 * Used for Terms, Tax Inclusion, and Tax Rate selectors.
 */
export default function SimpleDropdown({
  value,
  options,
  onSelect,
  placeholder = '',
  inputClassName = '',
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 0 });
  const inputRef = useRef(null);

  const selected = options.find((o) => o.value === value);
  const label = selected ? selected.label : '';

  useEffect(() => {
    if (isOpen && inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
      setDropdownPos({
        top: rect.bottom + window.scrollY + 4,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
  }, [isOpen]);

  return (
    <div className="relative">
      <input
        ref={inputRef}
        type="text"
        value={label}
        readOnly
        onClick={() => setIsOpen(true)}
        onFocus={() => setIsOpen(true)}
        onBlur={() => setTimeout(() => setIsOpen(false), 150)}
        placeholder={placeholder}
        className={`w-full px-3 py-2 text-sm border border-gray-300 rounded cursor-pointer focus:outline-none focus:ring-1 focus:ring-blue-500 ${inputClassName}`}
      />

      {isOpen && (
        <div
          className="bg-white border border-gray-200 rounded shadow-lg max-h-72 overflow-y-auto z-[10000]"
          style={{ position: 'fixed', top: dropdownPos.top, left: dropdownPos.left, width: dropdownPos.width }}
        >
          {options.map((opt) => (
            <div
              key={opt.value}
              onClick={() => { setIsOpen(false); onSelect?.(opt.value); }}
              className="p-3 cursor-pointer border-b border-gray-50 hover:bg-gray-50 text-sm text-gray-900"
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
